import { SVGProps } from 'react';

export const BlueLogoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="103"
      height="63"
      viewBox="0 0 103 63"
      fill="none"
      {...props}
    >
      <path
        d="M16.8722 32.7408C17.1845 36.6587 19.6651 39.3404 24.7823 39.3404C28.9628 39.3404 31.3392 37.9125 31.3392 34.3776C31.3392 31.2432 29.1883 29.676 23.6721 27.8476C14.1315 24.6784 10.4715 20.8998 10.4715 14.9619C10.4715 7.09108 16.1264 0.770088 28.0955 0.770088C38.9023 0.770088 45.3552 5.99401 45.5287 14.5439H34.2015C34.0974 12.3673 33.1607 9.18066 27.8006 9.18066C24.6262 9.18066 22.1283 10.504 22.1283 13.5688C22.1283 15.8151 23.6895 17.243 29.1189 19.0714C38.7463 22.2928 43.2736 26.1412 43.2736 32.9846C43.2736 40.9598 37.9135 47.6465 23.9323 47.6465C11.9285 47.6465 5.78785 41.8479 5.52765 32.7408H16.8722Z"
        fill="#01183F"
      />
      <path
        d="M64.4187 1.5191L54.8434 46.8806H43.4468L53.0221 1.5191H64.4187Z"
        fill="#01183F"
      />
      <path
        d="M69.0501 1.5191H87.6803C97.1861 1.5191 101.575 6.46446 101.575 12.8377C101.575 17.9224 98.73 22.0667 93.6995 23.808C96.874 25.1663 99.3545 28.7012 99.3545 32.7062C99.3545 41.4999 92.4853 46.8806 81.2448 46.8806H59.4576L69.0328 1.5191H69.0501ZM72.3113 38.6789H79.8571C84.4539 38.6789 87.4201 36.5719 87.4201 32.5843C87.4201 29.3977 85.6681 27.5345 80.8631 27.5345H74.6358L72.3113 38.6789ZM83.1528 19.3328C87.1772 19.3328 90.0914 17.8005 90.0914 14.0915C90.0914 10.661 87.4895 9.73815 84.8875 9.73815H78.3826L76.3704 19.3328H83.1355H83.1528Z"
        fill="#01183F"
      />
      <path
        d="M95.9057 55.3432L94.5005 62.3085H0.5L1.90516 55.3432H95.9057Z"
        fill="#2FCFD3"
      />
    </svg>
  );
};
